import moment from 'moment';
export default {
	isMmcAdmin: false,
	maxCnt: 0,
	sumCnt: 0,
	resultList: {},
	graphList: [],
	searchParams: SEARCH_PARAMS(),
	usePlCdList: [] //사용장소 selectBox
};

function SEARCH_PARAMS() {
	return {
		strDt: moment().format('YYYY'),
		period: 'month',
		usePlCd: ''
	};
}

export { SEARCH_PARAMS };
